export type EngineErrorCode =
  | 'unsupported'
  | 'canceled'
  | 'target-unreachable'
  | 'decode-failed'
  | 'encode-failed'
  | 'unknown';

/** Errors the UI can show as-is. Messages are plain language, no jargon. */
export class EngineError extends Error {
  readonly code: EngineErrorCode;
  constructor(code: EngineErrorCode, message: string) {
    super(message);
    this.name = 'EngineError';
    this.code = code;
  }
}

export function toEngineError(err: unknown): EngineError {
  if (err instanceof EngineError) return err;
  const message = err instanceof Error ? err.message : String(err);
  if (/out of memory|allocation/i.test(message)) {
    return new EngineError('unknown', 'Your browser ran out of memory. Try a shorter video.');
  }
  return new EngineError('unknown', `Something went wrong: ${message}`);
}
